import ReactDOM from "react-dom";
import { Suspense } from "react";
import App from "./App";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ServerErrorProvider } from "./Context/ServerErrorContext";

const queryClient = new QueryClient({
  refetchOnWindowFocus: false, // Disable refetch on window focus
  retry: 0, // Set retry count to 0
});

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <ServerErrorProvider>
    <Suspense fallback={<div>Loading...</div>}>
    <App />
    </Suspense>
    </ServerErrorProvider>
  </QueryClientProvider>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
